import { makeStyles, shorthands } from "@fluentui/react-components";

export const SignInHeaderNavStyles = makeStyles({
  main: {
    display: "flex",
    flexDirection: "row",
    width: "auto",
    alignItems: "center",
    margin: "0 auto",
    gap: "12px",
    ...shorthands.borderRadius("var(--None, 0px)"),
    ...shorthands.padding("10.5px", "21px"),
  },
  text: {
    fontFamily: "Segoe UI",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "22px",
    paddingLeft: "35px",
    "@media (max-width: 375px)": {
      paddingLeft: "0px",
    },
    "@media (max-width: 325px)": {
      fontSize: "8px",
      lineHeight: "11px",
    },
  },
  button: {
    paddingTop: "9px",
    paddingBottom: "9px",
    paddingLeft: "14px",
    paddingRight: "14px",
    "@media (max-width: 540px)": {
      paddingLeft: "7px",
      paddingRight: "7px",
    },
  },
  buttonText: {
    fontFamily: "Segoe UI",
    fontSize: "12px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "18px",
  },
});
